import { render, staticRenderFns } from "./RadiofrequencyLesioning.vue?vue&type=template&id=0d47d424&scoped=true"
import script from "./RadiofrequencyLesioning.vue?vue&type=script&lang=js"
export * from "./RadiofrequencyLesioning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47d424",
  null
  
)

export default component.exports